import { render, staticRenderFns } from "./PerfectUnderstand.vue?vue&type=template&id=1e3b4d70&scoped=true&"
import script from "./PerfectUnderstand.vue?vue&type=script&lang=js&"
export * from "./PerfectUnderstand.vue?vue&type=script&lang=js&"
import style0 from "./PerfectUnderstand.vue?vue&type=style&index=0&id=1e3b4d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b4d70",
  null
  
)

export default component.exports